module.exports = __webpack_public_path__ + "img/MD_Headshot.cf4b9583.jpg";